/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PrinterIcon = /*#__PURE__*/ createSvgIcon(
  'PrinterIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.568 5.322a1.73 1.73 0 01.662-.132h13.54a1.73 1.73 0 011.73 1.73v5.54a1.73 1.73 0 01-1.73 1.73h-1.72v-1h1.72a.73.73 0 00.73-.73V6.92a.73.73 0 00-.73-.73H3.23a.73.73 0 00-.73.73v5.54a.73.73 0 00.73.73H5v1H3.23a1.73 1.73 0 01-1.73-1.73V6.92a1.73 1.73 0 011.068-1.598z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.58 1.5h10.84v4.19h-1V2.5H5.58v3.19h-1V1.5zM4.58 10.12h10.85v8.38H4.58v-8.38zm1 1v6.38h8.85v-6.38H5.58zM13.19 8.15a.5.5 0 01.5-.5h1.85a.5.5 0 010 1h-1.85a.5.5 0 01-.5-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.08 13.58H6.92v-1h6.16v1zM10.62 16.04h-3.7v-1h3.7v1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default PrinterIcon;
